import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#464646",
      "clip-path": "url(#clip0_3323_22163)"
    }, [
      _createElementVNode("path", { d: "M12.02 10.629c-.39.29-.738.633-1.04 1.016-.881-.393-1.94-.643-3.163-.643-4.105 0-6.377 2.801-6.377 4.311 0 .193.098.257.331.257h7.927c.01.479.084.942.212 1.382H2.191C.707 16.952 0 16.494 0 15.487 0 13.09 2.96 9.62 7.817 9.62c1.63 0 3.046.392 4.202 1.009m-.338-6.446c0 2.362-1.736 4.293-3.865 4.293-2.128 0-3.864-1.922-3.864-4.275C3.953 1.876 5.698 0 7.817 0c2.138 0 3.864 1.84 3.864 4.183m-6.289.018c0 1.62 1.119 2.893 2.424 2.893 1.315 0 2.424-1.29 2.424-2.911 0-1.602-1.09-2.8-2.424-2.8-1.323 0-2.424 1.226-2.424 2.818M20 15.35c0 2.536-2.084 4.65-4.544 4.65-2.495 0-4.544-2.096-4.544-4.65s2.049-4.65 4.544-4.65c2.487 0 4.544 2.096 4.544 4.65m-5.098-2.352v1.785h-1.745c-.33 0-.545.22-.545.567 0 .339.214.559.545.559h1.745v1.793c0 .33.214.559.554.559.331 0 .546-.229.546-.558v-1.794h1.744c.33 0 .555-.22.555-.559 0-.348-.224-.567-.555-.567h-1.744v-1.785c0-.33-.215-.559-.546-.559-.34 0-.554.23-.554.559" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_3323_22163" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }